<button
	*ngIf="showSettings"
	(click)="onSettingsClick($event)"
	class="p-0 w-auto p-button-text flex-none"
	icon="spreeng spreeng-gearing"
	pButton
></button>
<i
	*ngIf="isSuggestion"
	class="
		rounded-full
		fa-regular fa-exclamation
		w-4
		h-4
		flex-none
		leading-4
		text-center
		p-background-color-secondary p-color-secondary-text
	"
></i>
<span class="text-xs truncate">
	<ng-content></ng-content>
</span>
